import React, { useEffect, useRef, useState } from "react";
import styles from "./blog.module.scss";
import { Outlet } from "react-router-dom";
import NavTabs from "../../components/mui/tabs/NavTab";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { useDispatch } from "react-redux";
import { getActiveProducts } from "../../store/actions";
const tabs = [
  {
    id: "1",
    title: "Active",
    link: "/blog",
  },
  {
    id: "2",
    title: "InActive",
    link: "/blog/inActive",
  },
];

const Blog = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getActiveProducts());
  }, []);

  return (
    <div className={styles.container}>
      {/* <div className={styles.heading}>OFFERS</div> */}
      <StatusCard
        leftContent="BLOG" // or any icon/component
      />

      <div className={styles.top}>
        <NavTabs data={tabs} variant={"fullWidth"} />
      </div>

      <div className={styles.bottom}>
        <Outlet />
      </div>
    </div>
  );
};

export default Blog;
